export interface IParcelHrmData {
    PID: string;
    ByLawId: number;
    ByLawCode: string;
    ByLawName: string;
    ZoneByLawId: number;
    Zone: string;
    PollDistId: number;
    PollDistName: string;
    Councillor: string;
    WasteCollect: string;
    WasteCollectArea: string;
    WasteCollectContractor: string;
}

export class ParcelHrmData implements IParcelHrmData {
    public PID = '';
    public ByLawId = -1;
    public ByLawCode = '';
    public ByLawName = '';
    public ZoneByLawId = -1;
    public Zone = '';
    public PollDistId = -1;
    public PollDistName = '';
    public Councillor = '';
    public WasteCollect = '';
    public WasteCollectArea = '';
    public WasteCollectContractor = '';
    constructor(
        hrmParcelObject: any,
    ) {
        this.PID = hrmParcelObject.pid;
        this.ByLawId = hrmParcelObject.byLawId;
        this.ByLawCode = hrmParcelObject.byLawCode;
        this.ByLawName = hrmParcelObject.byLawName;
        this.ZoneByLawId = hrmParcelObject.zoneByLawId;
        this.Zone = hrmParcelObject.zone;
        this.PollDistId = hrmParcelObject.pollDistId;
        this.PollDistName = hrmParcelObject.pollDistName;
        this.Councillor = hrmParcelObject.councillor;
        this.WasteCollect = hrmParcelObject.wasteCollect;
        this.WasteCollectArea = hrmParcelObject.wasteCollectArea;
        this.WasteCollectContractor = hrmParcelObject.wasteCollectContractor;
    }
}

